const config = window.APP_CONFIG;

const emailTemplatesEN = [
    {
        id: 0,
        language: "en",
        subject: "Quick response",
        body: `<p>Hello {{nickname}}</p><p>I'm currently in a meeting and need you to carry out a quick task for me. Send me your WhatsApp number and wait for my message.</p>
  <p class="pt-4">Kind regards,</p><p>${config.CEO}</p>`,
        sender: `<p class="malicious" title="This appears to be a personal Gmail address. The account was likely compromised and the name was changed to impersonate your CEO">${config.CEO} &lt;alainhenrard76@gmail.com&gt;</p>`,
        isPhishing: true,
        footer: ``
    },
    {
        id: 1,
        language: "en",
        subject: "Unusual sign-in activity detected",
        body: `
  <div style="text-align:center;">
    <img src="/images/microsoft.png" alt="Microsoft logo" style="display:block; margin: 0 auto; height: 150px;" />
    <p class="pb-4" style="font-size:15px; line-height:1.6; color:#333;">
      We detected a sign-in attempt on your Microsoft account from a new device or location.
    </p>
    <p style="font-size:15px; line-height:1.6; color:#333;">
      We recommend you check your account settings immediately.
    </p>
    <div style="margin: 24px 0;">
      <a
        href="https://micr0s0ft.com/login"
        class="malicious"
        title="Caution: suspicious domain"
        style="background:#dc3545;color:white;padding:12px 20px;border-radius:4px;font-weight:bold;"
      >
        Check activity
      </a>
    </div>
    <p style="font-size:13px; color:#666;">Activity detected: 05 June 2025 at 10:42 (CET)</p>
  </div>`,
        sender: `<p class="malicious" title="Suspicious sender with lookalike domain">Microsoft Security &lt;security@micr0s0ft.com&gt;</p>`,
        isPhishing: true,
        footer: `
  <div style="font-size:12px; color:#888; padding-top:10px; text-align:center;">
    This email was generated automatically. Do not reply directly.<br />
    Visit your <a href="https://account.microsoft.com/security" style="color:#dc3545; text-decoration:underline;">security settings</a> for more info.
  </div>`
    },
    {
        id: 4,
        language: "en",
        subject: "Important security update required – complete today",
        body: `
  <div style="text-align:center;">
    <p class="pb-4" style="font-size:15px; line-height:1.6; color:#333;">Good morning {{nickname}},</p>
    <p class="pb-4" style="font-size:15px; line-height:1.6; color:#333;">
      An important security update is available for your workstation. To minimize risk, we ask you to install it today.
    </p>
    <p style="font-size:15px; line-height:1.6; color:#333;">
      Click the button below to start the update immediately.
    </p>
    <div style="margin: 24px 0;">
      <a
        href="https://${config.companyDomainPhishing}/update"
        class="malicious"
        title="Domain does not match your organization"
        style="background:#ffc107; color:black; padding:12px 20px; border-radius:4px; font-weight:bold;"
      >
        Start update
      </a>
    </div>
    <p style="font-size:13px; color:#666;">
      Update ID: KB509821 — available since ${new Date().toLocaleDateString('en-GB')}
    </p>
  </div>`,
        sender: `<p class="malicious" title="Sender domain differs from internal IT management">IT Admin &lt;it@${config.companyDomainPhishing}&gt;</p>`,
        isPhishing: true,
        footer: `
  <div style="font-size:12px; color:#888; padding-top:10px; text-align:center;">
    Questions? Contact <a href="mailto:it@${config.companyDomainPhishing}" style="text-decoration:underline;color:#ffc107;">it@${config.companyDomainPhishing}</a><br />
    This message was automatically sent from the IT management system.
  </div>`
    },
    {
        id: 5,
        language: "en",
        subject: "Someone responded to your post",
        body: `<div style="text-align:center;">
    <img src="/images/linkedin.png" alt="LinkedIn" style="display:block;margin:0 auto;height:200px;" />
    <p style="font-size:15px; line-height:1.6;">Someone just commented on one of your recent posts.</p>
    <p style="font-size:15px; line-height:1.6;">View the response and join the conversation.</p>
    <div class="relative group" style="margin: 20px 0; display: inline-block;">
      <a
        href="https://www.Iinkedin/activity/post/8394"
        class="malicious"
        style="background:#0077b5; color:white; padding:10px 20px; border-radius:4px; display:inline-block; font-weight:bold;"
      >
        View activity
      </a>
      <div
        class="hidden group-hover:block absolute bottom-full left-1/2 transform -translate-x-1/2 mb-2 bg-black text-white text-xs font-mono px-3 py-2 rounded shadow-lg z-50 max-w-xs text-center"
      >
        Warning: Sender appears to be linkedin.com but is actually Iinkedin.com.<br />You could spot this by hovering over the button.
      </div>
    </div>
  </div>`,
        sender: `
  <span class="relative group inline-block">
    <span style="font-family: monospace;" class="malicious">
      LinkedIn Notifications &lt;noreply@Iinkedin.com&gt;
    </span>
    <div
      class="hidden group-hover:block absolute bottom-full left-1/2 transform -translate-x-1/2 mb-2 bg-black text-white text-xs font-mono px-3 py-2 rounded shadow-lg z-50 max-w-xs text-center"
    >
      Sender appears to be linkedin.com but is actually Iinkedin.com.<br />
      You could spot this by hovering over the domain.
    </div>
  </span>`,
        isPhishing: true,
        footer: `<div style="font-size:12px;color:#888;padding-top:10px;text-align:center;">
    You are receiving this notification based on your settings.<br />
    <a href="https://www.Iinkedin.com/settings/" style="color:#0077b5;text-decoration:underline;">Manage your settings</a>
  </div>`
    },
    {
        id: 7,
        language: "en",
        subject: "You have a new comment on your post",
        body: `
  <div style="text-align:center;">
    <img src="/images/fb.svg" alt="Facebook logo" style="display:block; margin: 0 auto 16px; height:40px;" />
    <p style="font-size:15px; color:#333; line-height:1.6;">
      Someone commented on one of your recent Facebook posts.
    </p>
    <p style="font-size:15px; color:#333; line-height:1.6;">
      View the comment and stay in the loop.
    </p>
    <div style="margin: 20px 0;">
      <div class="relative inline-block group mt-4">
        <a
          href="https://facebook-alerts.com/meldingen"
          class="malicious"
          title="This button leads to a non-official Facebook URL"
          style="background:#1877f2; color:white; padding:12px 20px; border-radius:4px; font-weight:bold; display:inline-block;"
        >
          View your notification
        </a>
        <div class="absolute left-1/2 transform -translate-x-1/2 mt-1 h-[2px] w-full bg-red-600 rounded"></div>
      </div>
    </div>
  </div>`,
        sender: `<p class="malicious" title="Spoofed sender address, this is not a valid Facebook domain">Facebook Notifications &lt;no-reply@facebook-alerts.com&gt;</p>`,
        isPhishing: true,
        footer: `
  <div style="font-size:12px; color:#888;padding-top:10px; text-align:center;">
    This notification was sent to your account settings.<br />
    Facebook never asks for personal info via email.<br />
    <p href="https://facebook-alerts.com/meldingen" class="malicious" title="Non-official Facebook URL">View your notification</p>
  </div>`
    },
    {
        id: 9,
        language: "en",
        subject: "Your Eneco invoice for this month is available",
        body: `
  <div style="text-align:center;">
    <img src="/images/Eneco.png" alt="Eneco logo" style="display:block; margin: 0 auto; height: 150px;" />
    <p style="font-size:15px; line-height:1.6; color:#333;">
      Your new energy invoice is available in your customer portal.
    </p>
    <p style="font-size:15px; line-height:1.6; color:#333;">
      You can pay it quickly and securely via the QR code below.
    </p>
    <div style="margin: 24px 0;" class="group relative inline-block">
      <img
        src="https://api.qrserver.com/v1/create-qr-code/?data=https://eneco-facturatie.be&size=150x150"
        class="malicious"
        title="QR code leads to a domain that is not officially Eneco"
        style="display:block; margin: 0 auto;"
      />
      <div class="absolute left-1/2 transform -translate-x-1/2 mt-1 h-[2px] w-[150px] bg-red-600 rounded"></div>
    </div>
    <p style="font-size:13px; color:#666;">Invoice number: ENE-202406-8127</p>
  </div>`,
        sender: `<p class="malicious" title="Domain is not an official domain of Eneco">Eneco Belgium &lt;facturen@eneco-facturatie.be&gt;</p>`,
        isPhishing: true,
        footer: ``
    }

]

export default emailTemplatesEN